import { Component, Input } from '@angular/core';
import { IBodyCell, BodyCell } from '../../../holders/body-cell.component';
import { Selection } from '../../../../utility/selection.class';

@Component({
   selector: 'app-single-selection',
   template: `
      <button class="button" (click)="toggle()">
         <svg class="svg svg-icon" viewBox="0 0 20 20" width="25" height="25">
            <path class="selector" [ngClass]="{ selected: cell.selection.isSelected(value) }"
                  d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,
                  0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,
                  0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,
                  7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911
                  ,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z" ></path>
         </svg>
      </button> 
  `,
   styleUrls: ['./single.component.scss']
})
export class SingleSelectionCellComponent<D extends object> implements IBodyCell<D> {
   @Input() public value: D;
   @Input() public cell: SingleSelectionCell<D>;

   public toggle() {
      const { isSelected, toggle } = this.cell.selection;
      const isCurrentlySelected = isSelected(this.value);

      this.cell.selection.unselectAll();
      
      if (!isCurrentlySelected) {
         toggle(this.value);
      }
   }
}


export class SingleSelectionCell<D extends object> extends BodyCell<D> {
   constructor(
      public selection: Selection<D>
   ) {
      super(SingleSelectionCellComponent, () => ``);
   }
}